import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=237ea58e&"
import script from "./TablePager.vue?vue&type=script&lang=ts&"
export * from "./TablePager.vue?vue&type=script&lang=ts&"
import style0 from "./TablePager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TablePager.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports